// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2bejo","title":"ClientReferral_title__mSJtT","itemText":"ClientReferral_itemText__l_BPQ"};